/* eslint-disable class-methods-use-this */
import DemandECE, {
  DemandEntity,
  DemandStatus,
  DemandStatusOptions,
  DemandWDH,
  MotifTransco,
  DemandTranscoAPI,
  DemandTranscoECE,
} from 'utils/__interfaces/MyDemands/DemandEntity'
import { formatDate } from 'utils/Common/date-utils'
import status from 'utils/MyDemands/demand-utils'
import EnumDemandStatus, {
  IconsDemandStatus,
} from 'utils/__enums/MyDemands/demandStatus'

const statusOrder = [
  EnumDemandStatus.ALL.toString(),
  EnumDemandStatus.EN_COURS.toString(),
  EnumDemandStatus.ENVOYE.toString(),
  EnumDemandStatus.EN_ATTENTE_INFO_CLIENT.toString(),
  EnumDemandStatus.PLANIFIE.toString(),
  EnumDemandStatus.TRAITEE.toString(),
  EnumDemandStatus.ANNULE.toString(),
]
class DemandNormalizer {
  normalize(demandList: DemandECE[]): DemandEntity[] {
    return demandList.map((demand) => {
      const address = `${demand.etsPresteAdresse ?? ''} ${
        demand.etsPresteCode ?? ''
      }  ${demand.etsPresteVille ?? ''}`
      const date = formatDate(demand.createdAt, 'DD/MM/YYYY')
      return {
        id: String(demand.id),
        numDemand: demand.numDemand,
        motif: demand.transco.demandMotif.label,
        site: address,
        dateCreation: date,
        statut: demand.statut?.valueECE,
      }
    })
  }

  normalizeWDH(
    demandList: DemandWDH[],
    transcoMotifs: MotifTransco[],
    transcoStatus: {
      [key: string]: string[]
    }
  ): DemandEntity[] {
    return demandList.map((demand) => {
      const address = `${demand.AdresseSitePrestation ?? ''} 
      ${demand.CodePostalSitePrestation ?? ''}  ${
        demand.VilleSitePrestation ?? ''
      }`
      const date = formatDate(demand.DateCreationExterne, 'DD/MM/YYYY')
      const motif = transcoMotifs.find(
        (item: { type: string; motif: string; detail: string }) =>
          item.type === (demand.Type ?? '') &&
          item.motif === (demand.Motif ?? '') &&
          item.detail === (demand.Detail ?? '')
      )?.motifECE
      const statut = Object.keys(transcoStatus).find((key) =>
        transcoStatus[key].includes(demand.Statut)
      )
      return {
        id: String(demand.idDemandeCRM),
        numDemand: demand.NumeroDemande,
        motif: motif ?? 'Demande requalifiée / traitée via un autre canal',
        site: address,
        dateCreation: date,
        statut: status(statut ?? '', demand?.DateFinPlanification ?? '', motif),
      }
    })
  }

  normalizeTransco(listeTransco: DemandTranscoAPI[]): DemandTranscoECE[] {
    return listeTransco.map((item) => ({
      id: item.id,
      demandCategoryECE: {
        id: item.demandCategory.id,
        label: item.demandCategory.label,
        value: item.demandCategory.code,
        displayOrder: item.demandCategory.displayOrder,
      },
      demandMotifECE: {
        id: item.demandMotif.id,
        label: item.demandMotif.label,
        value: item.demandMotif.code,
        displayOrder: item.demandMotif.displayOrder,
        formNumber: item.formNumber,
      },
      typeDemand: item.ccapTypeDemand,
      motifDemand: item.ccapMotif,
      detailDemand: item.ccapDetail,
      defaultValue: item.defaultValue,
    }))
  }

  normalizeStatus(
    listStatus: DemandStatus[]
  ): {
    statusOptions: DemandStatusOptions[]
    statusTransco: { [key: string]: string[] }
  } {
    const statusOptions = listStatus
      .filter(
        (item, index, self) =>
          item.codeECE !== 'EN_COURS_DE_TRANSMISSION' && // Exclure l'élément avec valueECE égal à "En cours de transmission"
          index === self.findIndex((s) => s.valueECE === item.valueECE) // Filtrer les doublons
      )
      .map(({ valueECE }) => ({
        label: valueECE,
        value: valueECE,
        icon: IconsDemandStatus[valueECE],
      }))

    const statusTransco: { [key: string]: string[] } = {}
    // Certains status ECE ont plusieurs correspondance CCAP, donc on les regroupe
    listStatus.forEach((item) => {
      if (statusTransco[item.valueECE])
        statusTransco[item.valueECE].push(item.valueCCAP)
      else statusTransco[item.valueECE] = [item.valueCCAP]
    })

    statusTransco[EnumDemandStatus.PLANIFIE] = ['Clôturée']

    statusOptions.push(
      {
        label: EnumDemandStatus.ALL,
        value: 'All',
      },
      {
        label: EnumDemandStatus.PLANIFIE,
        value: EnumDemandStatus.PLANIFIE,
        icon: IconsDemandStatus[EnumDemandStatus.PLANIFIE],
      }
    )

    // Ordonner les status
    statusOptions.sort(
      (a, b) => statusOrder.indexOf(a.value) - statusOrder.indexOf(b.value)
    )
    return {
      statusOptions,
      statusTransco,
    }
  }
}

export default new DemandNormalizer()
